import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment/moment';
import EventEmitter from 'src/utils/EventEmitter';
import { useAxiosInstance } from 'src/utils/useAxiosInstance';

export const TableBody = ({
  ordersData,
  selectedProduct,
  headerData,
  expandProduct,
  isLoading,
  selectedTab,
}) => {
  const { axiosInstance } = useAxiosInstance();

  function openPopupDetailPopup(orderData) {
    EventEmitter.emit("show_custom_popup", { value: true, type: 'order', data: { orderData, selectedTab } });
  }

  function openAcceptMovementPopup(orderData) {
    EventEmitter.emit("show_custom_popup", { value: true, type: 'movement', data: { orderData, selectedTab } });
  }

  async function openOrderReceipt(transferReceiptId) {
    try {
      const res = await axiosInstance.get(`/consignment-transfer-order/${transferReceiptId}/view-stock-receipt`);
      window.open(res.data.data.signedUrl, '_blank');
    } catch (error) {
      console.error('Error opening order receipt:', error);
    }
  }

  var list = [];

  var order_data = ordersData;

  if (order_data.length === 0) {
    list.push(
      <div className="list no-data" key="none">
        <div>
          <img src="/static/images/icon/no_orders-icon.svg" alt="no-orders" />
          <span
            style={{
              fontWeight: '600',
              fontSize: '12px',
              lineHeight: '22px',
              color: '#000000',
              marginTop: '16px',
            }}
          >
            No Orders Yet
          </span>
        </div>
      </div>
    );
  } else {
    /* eslint-disable array-callback-return*/
    order_data.map((value, index) => {
      const id = selectedTab === 'Completed' ? value.transferReceiptId : value.orderId;
      const date = value.postingDate
        ? moment(value.postingDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '';

      let past_due = 0;

      if (date) {
        try {
          var difference = moment
            .duration(
              moment()
                .startOf('day')
                .diff(moment(date, 'DD/MM/YYYY').startOf('day'))
            )
            .asDays();

          if (!isNaN(difference) && typeof difference == 'number') {
            past_due = Math.ceil(difference);
          }
        } catch {}
      }
      let past_due_level = 0;
      if (past_due < 5) {
        past_due_level = 1;
      } else if (past_due < 10) {
        past_due_level = 2;
      } else {
        past_due_level = 3;
      }

      let track_link = [];

      track_link.push(
        <div key={`track_order_${index}`}>
          {value.ERX_Courier_Tracking_Details &&
          value.ERX_Courier_Tracking_Details !== '' ? (
            <span
              className="track-order-link"
              onClick={() =>
                window.open(
                  'https://startrack.com.au/track/details/' +
                    value.ERX_Courier_Tracking_Details
                )
              }
            >
              click here
            </span>
          ) : (
            <div style={{ lineHeight: '14.5px' }}>-</div>
          )}
        </div>
      );

      var dispatch_address = value.transferFromAddress;
      if (dispatch_address) {
        dispatch_address +=
          ', ' +
          value.transferFromCity +
          ', ' +
          value.transferFromCounty +
          ', ' +
          value.transferFromPostCode;
      }

      var delivery_address = value.transferToAddress;
      if (delivery_address) {
        delivery_address +=
          ', ' +
          value.transferToCity +
          ', ' +
          value.transferToCounty +
          ', ' +
          value.transferToPostCode;
      }

      var isAcknowledgements = value.status === 'Acknowledged';

      const isClicked = selectedProduct === value.id;

			const uniqueSKUs = new Set(value.lineItems.map((item) => item.itemNo));
      const totalDistinctSKUs = uniqueSKUs.size;
			const totalUnits = value.lineItems.reduce(
        (sum, item) => sum + Number(item.quantity),
        0
      );

      list.push(
        <div key={index}>
          <div
            key={index}
            className="list"
            style={{ background: isClicked ? '#F5F6F8' : '#FFFFFF' }}
          >
            <div
              className="child"
              style={{ '--width': headerData[0].width_table + '%' }}
              onClick={() => expandProduct(value.id)}
            >
              <div className="text">{id}</div>
            </div>
            <div
              className="child"
              style={{ '--width': headerData[1].width_table + '%' }}
              onClick={() => expandProduct(value.id)}
            >
              <div className="text">{date}</div>
            </div>

            {selectedTab !== 'Acknowledgements' ? (
              <>
                <div
                  className="child"
                  style={{ '--width': headerData[2].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div className="text">{totalDistinctSKUs}</div>
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[3].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div className="text">{totalUnits}</div>
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[4].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div
                    className={`text order_status ${selectedTab === 'In Progress' ? 'In_Progress' : selectedTab}`}
                    style={{ height: 'fit-content' }}
                  >
                    {selectedTab}
                  </div>
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[5].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div className="text">
                    <div
                      className="view"
                      onClick={() => selectedTab === 'Completed' ? openOrderReceipt(value.transferReceiptId) : openPopupDetailPopup(value)}
                    >
                      click here
                    </div>
                  </div>
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[6].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div className="text action-movements">
                    <div>
                      {isClicked ? (
                        <ExpandLessIcon
                          style={{ fontSize: '24px', color: '#000000' }}
                        />
                      ) : (
                        <ExpandMoreIcon
                          style={{ fontSize: '24px', color: '#797979' }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  className="child"
                  style={{ '--width': headerData[2].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div className={`past_due level-${past_due_level}`}>
                    <div className="text">
                      {past_due > 0 ? '+' : ''}
                      {past_due} day{past_due > 1 ? 's' : ''}
                    </div>
                  </div>
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[3].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div className="text">{track_link}</div>
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[4].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div className="text">
                    <div
                      className="view"
                      onClick={() => openAcceptMovementPopup(value)}
                    >
                      view
                    </div>
                  </div>
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[5].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div
                    className={`text order_status ${isAcknowledgements ? 'Acknowledged' : 'Unacknowledged'}`}
                    style={{ height: 'fit-content', textTransform: 'capitalize' }}
                  >
                    {value.status}
                  </div>
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[6].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  {!isAcknowledgements && (
                    <div className="text">
                      <div
                        className="view accept"
                        onClick={() =>
                          openAcceptMovementPopup(value)
                        }
                      >
                        Accept movement
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="child"
                  style={{ '--width': headerData[7].width_table + '%' }}
                  onClick={() => expandProduct(value.id)}
                >
                  <div className="text action-movements">
                    <div>
                      {isClicked ? (
                        <ExpandLessIcon
                          style={{ fontSize: '24px', color: '#000000' }}
                        />
                      ) : (
                        <ExpandMoreIcon
                          style={{ fontSize: '24px', color: '#797979' }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          {isClicked && (
            <>
              <div style={{ background: '#F5F6F8' }}>
                <div className="orders-divider"></div>
              </div>
              <div key={`detail_${index}`} className="orders-content-detail">
                <div className="child" style={{ '--width': '4%' }}></div>
                <div
                  className="child orders-detail-left"
                  style={{ display: 'block' }}
                >
                  <div className="orders-detail-left-text top">
                    Order Details
                  </div>
                  <div>
                    <div className="orders-detail-left-text">
                      Dispatch Address:
                    </div>
                    <div className="orders-detail-left-value">
                      {dispatch_address || '-'}
                    </div>
                  </div>
                  <div>
                    <div className="orders-detail-left-text">
                      Delivery Address:
                    </div>
                    <div className="orders-detail-left-value">
                      {delivery_address || '-'}
                    </div>
                  </div>
                  <div style={{ minHeight: '30px' }}></div>
                </div>
              </div>
            </>
          )}
        </div>
      );
    });
    /* eslint-enable array-callback-return*/
  }

  return (
    <div className="orders-table-body">
      {isLoading ? (
        <div className="list no-data" style={{ minHeight: '100px' }}>
          {' '}
          <div
            className="loader-medium"
            style={{ marginTop: '20px', marginBottom: '10px' }}
          ></div>
        </div>
      ) : (
        list
      )}
    </div>
  );
};